import React, {Component} from 'react'
import PropTypes from 'prop-types';
import './submitButton.css';
import Smiles from "../smiles";

class SubmitButton extends Component {

    render() {
        return (
            <button
                className="SubmitButton"
                onClick={this.props.onClick}
            >{'Odeslat'}</button>
        );
    }

}

Smiles.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default SubmitButton;


// WEBPACK FOOTER //
// ./src/components/submitButton/index.js